
import { onMounted, ref } from '@nuxtjs/composition-api'

export default {
  setup () {
    const dialog = ref(false)
    const restart = () => {
      dialog.value = false
      location.reload()
    }

    onMounted(() => {
      $nuxt.$on('cartItemsChanged', () => {
        dialog.value = true
      })
    })

    return {
      dialog,
      restart
    }
  }
}
